import React, { useState } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import SaveReportModal from '../SaveReportModal';
import ReportSavedModal from '../ReportSavedModal';
import DownloadButton from './DownloadButton';
import SaveReportButton from './SaveReportButton';
import { SaveReportValues } from '../SaveReportModal/SaveReportModal.types';
import styles from './ReportActions.module.scss';

interface ReportActionsProps {
	className?: string;
	onSaveReport?: (values: SaveReportValues) => void;
	onDownload?: () => void;
	saveDisabled?: boolean;
	downloadDisabled?: boolean;
}

const ReportActions: React.FC<ReportActionsProps> = ({
	className,
	onSaveReport,
	onDownload,
	saveDisabled,
	downloadDisabled
}) => {
	const [isSaveModalVisible, setIsSaveModalVisible] = useState(false);
	const [isSavedModalVisible, setIsSavedModalVisible] = useState(false);
	const history = useHistory();

	const handleSave = (values: SaveReportValues) => {
		onSaveReport?.(values);
		setIsSaveModalVisible(false);
		setIsSavedModalVisible(true);
	};

	const handleViewSavedReports = () => {
		setIsSavedModalVisible(false);
		// getAppRoutes carries the tenant postfix the app is running under.
		history.push(getAppRoutes().SAVED_REPORTS);
	};

	return (
		<div className={classNames(styles.root, className)}>
			<SaveReportButton
				disabled={saveDisabled}
				onClick={() => setIsSaveModalVisible(true)}
			/>
			<DownloadButton disabled={downloadDisabled} onClick={onDownload} />

			<SaveReportModal
				visible={isSaveModalVisible}
				onCancel={() => setIsSaveModalVisible(false)}
				onSave={handleSave}
			/>

			<ReportSavedModal
				visible={isSavedModalVisible}
				onClose={() => setIsSavedModalVisible(false)}
				onViewSavedReports={handleViewSavedReports}
			/>
		</div>
	);
};

export { DownloadButton, SaveReportButton };
export type { SaveReportValues };
export default ReportActions;
